import * as React from "react";
import "./header.scss";
import classNames from "classnames";
import TooltipInfo from "../tooltipInfo/tooltipInfo";

interface HeaderProps {
  type: "big" | "medium" | "small";
  mainHeader?: string | React.ReactNode;
  additionalInfo?: string;
  tooltip?: string;
}

export default function Header(props: HeaderProps): React.ReactElement<HeaderProps> {
  return (
    <div className={classNames(`header ${props.type}`)}>
      <div className="main">
        {props.mainHeader}
        {props.tooltip && <TooltipInfo infoMessage={props.tooltip} />}
      </div>
      <div className="additional-info">
        {props.additionalInfo}
      </div>
    </div>
  );
}
